import { type FC, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { CmsError, Loading } from "src/components";
import { Routes } from "src/routes";
import { setAuthToken, useClearReferralCodeMutation, usePublicGoogleJwtQuery } from "src/serverApi";
import { useTranslation } from "src/translations";
import { logGtmEvent } from "src/utils";
import { clearProviderSignUpState, getProviderSignUpState, useUpdateProfileUser } from "../utils";

export const GoogleCallbackPage: FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const authParams = Object.fromEntries(searchParams.entries()) || {};

    const { data: googleJwt, isLoading, isError, error } = usePublicGoogleJwtQuery(authParams);
    const [clearReferralCode] = useClearReferralCodeMutation();
    const updateUserProfile = useUpdateProfileUser();

    const { referralCode, isSignUp, termsAndPrivacyAccepted } = getProviderSignUpState();

    useEffect(() => {
        if (!isLoading && googleJwt) {
            const { jwt } = googleJwt;
            if (jwt) {
                setAuthToken(jwt);
                updateUserProfile({ referredBy: referralCode, termsAndPrivacyAccepted }).then(() => {
                    logGtmEvent({ event: `user_google_${isSignUp ? "registered" : "logged_in"}` });
                    clearProviderSignUpState();
                    clearReferralCode();
                    navigate(Routes.projects.path);
                });
            }
        }
    }, [isLoading, googleJwt, updateUserProfile, navigate, clearReferralCode, referralCode, isSignUp, termsAndPrivacyAccepted]);

    return isError ? <CmsError error={error} fallbackMessage={t("common.error")} /> : <Loading isFullPage />;
};
